import envVar from '../../config/envVars';
import { UpdatePaymentConcessionProps } from '../../modules/FullPaymentConcession/types';
import httpGet from '../httpClient/httpGet';
import httpPut from '../httpClient/httpPut';

interface FetchPaymentConcessionProps {
  school: string;
  academicYear: string;
}

const fetchPaymentConcessionMaster = async ({
  school,
  academicYear
}: FetchPaymentConcessionProps) =>
  await httpGet(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/schools/${school}/academicYear/${academicYear}/default-concessions-master`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_PAYMENTS_API_TOKEN}`
      }
    }
  );

interface UpdatePaymentConcessionPayload extends FetchPaymentConcessionProps {
  payload: { grades: string[] } | UpdatePaymentConcessionProps;
}

const updatePaymentConcessionMaster = async ({
  school,
  academicYear,
  payload
}: UpdatePaymentConcessionPayload) =>
  await httpPut(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/schools/${school}/academicYear/${academicYear}/default-concessions-master`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_PAYMENTS_API_TOKEN}`
      }
    }
  );

const paymentConcessionMaster = {
  fetchPaymentConcessionMaster,
  updatePaymentConcessionMaster
};

export default paymentConcessionMaster;
